
import { ref, defineComponent, onMounted, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import _ from "lodash";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import ExportCustomerModal from "@/components/modals/forms/ExportCustomerModal.vue";
import Grid from "@/components/modals/facturas/Grid.vue";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import * as Yup from "yup";
import { ErrorMessage, Field, Form } from "vee-validate";
interface Buscador {
    estado?: number;
    factura?: number;
    empresaId?: number;
    fechaInicio?: Date;
    fechaTermino?: Date;
    proveedorId: number;
}

export default defineComponent({
    name: "kt-customer-list",
    components: {
        DataTable,
        Column,
        Grid,
        ErrorMessage,
        Field,
        Form,
    },

    setup() {
        const router = useRouter();
        const submitButton1 = ref<HTMLElement | null>(null);
        const submitButtonDatosBancarios = ref<HTMLElement | null>(null);
        const store = useStore();
        const id = ref(null);
        const verEditDatosBancarios = ref(false);

        const proveedorSeleccionado = ref(null);
        onMounted(() => {
            setCurrentPageBreadcrumbs("Proveedores", ["Página", "Dashboard"]);
            buscarUsuarios();
            getBancos();
        });

        const descargarDocumento = async (item) => {
            try {
                const resul = await store.dispatch(
                    Actions.DESCARGAR_DOCUMENTO_BANCO,
                    item.id
                );

                const url = `data:${resul.ContentType};base64,${resul.contenido}`;
                const descargar = document.createElement("a");
                const nombreDocumento = resul.nombre;

                descargar.href = url;
                descargar.download = nombreDocumento;
                descargar.click();
            } catch (error) {
                console.error(error);
            }
        };


        const buscador = ref<Buscador>({
            proveedorId: store.getters.currentUser.id,
        });
        const buscadorValidator = Yup.object().shape({});
        const buscarUsuarios = () => {
            store
                .dispatch(Actions.GET_PROVEEDORES)
                .then(() => {
                    loading.value = false;
                })
                .catch(() => {
                    const [error] = Object.keys(
                        store.getters.getProveedorErrors
                    );
                });
        };
        const dt = ref();
        const formatDate = (value) => {
            value = new Date(value);
            return value.toLocaleDateString("es-ES", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
        };
        const formatCurrency = (value) => {
            return value.toLocaleString("es-CL", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                style: "currency",
                currency: "CLP",
            });
        };
        const dataexport = () => {
            const newJson = store.getters.allProveedores.map((rec) => {
                return {
                    "Rut Proveedor": rec.rutProveedor,
                    Proveedor: rec.nombreProveedor,
                    "Nombre Contacto": rec.nombreCompleto,
                    Email: rec.contactoEmail,
                    Teléfono: rec.contactoTelefono,
                    "F. Actualización": formatDate(rec.fechaActualizacion),
                    "Medio Cuenta":rec.medioCuenta,
                    "Medio Nombre": rec.medioNombre,
                    Banco: rec.nombreBanco,
                    "Tipo Cuenta": rec.tipoCuenta,
                    "Número Cuenta": rec.numeroCuenta,

                };
            });
            return newJson;
        };

        const exportExcel = () => {
            import("xlsx").then((xlsx) => {
                const worksheet = xlsx.utils.json_to_sheet(dataexport());
                const workbook = {
                    Sheets: { data: worksheet },
                    SheetNames: ["data"],
                };
                const excelBuffer = xlsx.write(workbook, {
                    bookType: "xlsx",
                    type: "array",
                });
                saveAsExcelFile(excelBuffer, "proveedores");
            });
        };
        const saveAsExcelFile = (buffer, fileName) => {
            import("file-saver").then((FileSaver) => {
                let EXCEL_TYPE =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                let EXCEL_EXTENSION = ".xlsx";
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE,
                });
                FileSaver.saveAs(
                    data,
                    fileName +
                        "_export_" +
                        new Date().getTime() +
                        EXCEL_EXTENSION
                );
            });
        };
        const currentUser = computed(() => {
            return store.getters.currentUser;
        });
        const allProveedores = computed(() => {
            return store.getters.allProveedores;
        });
        const viewDocs = (proveedor) => {
            id.value = proveedor.id;
            visibleFull.value = true;
        };

        const abirirEditarDatosBancarios = (proveedor) => {
            id.value = proveedor.id;
            proveedorSeleccionado.value = proveedor;
            verEditDatosBancarios.value = true;
        };
        const cerrarEditDatosBancarios = () => {
            verEditDatosBancarios.value = false;

            // if (mostrarMensaje) {
            //     buscarUsuarios();
            //     Swal.fire({
            //         text: "Su información ha sido actualizada correctamente.",
            //         icon: "success",
            //         confirmButtonText: "Ok",
            //         buttonsStyling: false,
            //         customClass: {
            //             confirmButton: "btn btn-light-primary",
            //         },
            //     });
            // }
        };
        const filters1 = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
        const exportCSV = () => {
            dt.value.exportCSV();
        };
        const visibleFull = ref(false);
        const search = ref(null);
        const selectedUsuarios = ref(null);
        const loading = ref(true);

        const saveDatosBancarios = () => {
            if (submitButtonDatosBancarios.value) {
                submitButtonDatosBancarios.value.setAttribute(
                    "data-kt-indicator",
                    "on"
                );
                store
                    .dispatch(
                        Actions.UPD_PROVEEDOR,
                        proveedorSeleccionado.value
                    )
                    .then(() => {
                        submitButtonDatosBancarios.value?.removeAttribute(
                            "data-kt-indicator"
                        );

                        buscarUsuarios();
                        Swal.fire({
                            text: "Su información ha sido actualizada correctamente.",
                            icon: "success",
                            confirmButtonText: "Ok",
                            buttonsStyling: false,
                            customClass: {
                                confirmButton: "btn btn-light-primary",
                            },
                        });
                    })
                    .catch(() => {
                        const [error] = Object.keys(
                            store.getters.getProveedorErrors
                        );
                        Swal.fire({
                            text: store.getters.getProveedorErrors[error],
                            icon: "error",
                            confirmButtonText: "Ok",
                            buttonsStyling: false,
                            customClass: {
                                confirmButton: "btn btn-light-primary",
                            },
                        });
                    });
            }
        };

        const bancos = computed(() => {
            return store.getters.allBancos;
        });
        const getBancos = () => {
            store.dispatch(Actions.GET_BANCOS);
        };

        return {
            filters1,
            buscador,
            selectedUsuarios,
            loading,
            buscadorValidator,
            buscarUsuarios,
            submitButton1,
            viewDocs,
            allProveedores,
            visibleFull,
            id,
            exportExcel,
            formatDate,
            formatCurrency,
            verEditDatosBancarios,
            abirirEditarDatosBancarios,
            cerrarEditDatosBancarios,
            bancos,
            submitButtonDatosBancarios,
            proveedorSeleccionado,
            saveDatosBancarios,
            descargarDocumento

        };
    },
});
